import store from '@/store';

export const linkTo = {
    methods: {
        linkTo (url, router) {
            // are we linkinf internally or not
            if (router) {
                // internal and use router
                this.$router.push(url);
            } else {
                // route with javascript
                window.open(url, '_blank');
                store.dispatch('analytics/sendAnalyticsBeacon', {
                    logType: 'linkClicked',
                    page: url,
                    info: new Date(),
                });
            }
        },
    },
};

export default linkTo;
